module.exports = __webpack_public_path__ + "static/media/arrow-to-top.5137c0cc.svg";